import React from 'react';
import { useSelectedParam } from '../../model/selectedParam';
import { modalIds } from '../../constants';
import ChangeExecuteDateTime from './components/ChangeExecuteDateTime/ChangeExecuteDateTime';
import BaseModal from '../BaseModal/BaseModal';
import ChangeState from './components/ChangeState/ChangeState';
import AddComment from './components/AddComment/AddComment';
import ChangeMaster from './components/ChangeMaster/ChangeMaster';
import ChangeExecutor from './components/ChangeExecutor/ChangeExecutor';
import CheckingPaymentStatuses from './components/ChangePaymentStatus/CheckingPaymentStatuses';
import ChangeSign from './components/ChangeSign/ChangeSign';
import ChangeStage from './components/ChangeStage/ChangeStage';

const ModalFactory = ({ requests, onSuccess }) => {
  const param = useSelectedParam();

  const commonProps = { requests, onSuccess };

  switch (param?.id) {
    case modalIds.executeDateTime:
      return <ChangeExecuteDateTime {...commonProps} />;

    case modalIds.state:
      return <ChangeState {...commonProps} />;

    case modalIds.comment:
      return <AddComment {...commonProps} />;

    case modalIds.master:
      return <ChangeMaster {...commonProps} />;

    case modalIds.executor:
      return <ChangeExecutor {...commonProps} />;

    case modalIds.paymentState:
      return <CheckingPaymentStatuses {...commonProps} />;

    case modalIds.sign:
      return <ChangeSign {...commonProps} />;

    case modalIds.stageRequest:
      return <ChangeStage {...commonProps} />;

    default:
      return <BaseModal>Нет Данных</BaseModal>;
  }
};

export default ModalFactory;
